import CustomerHome from "../../../jsx/components/Dashboard/CustomerHome";

const CustomerHomeWrapper = () => {
  return <CustomerHome />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(CustomerHomeWrapper);
